import CustomerPage from "./customerPage"
export default CustomerPage;
